module.exports = __webpack_public_path__ + "static/homepage-button-hcp-bda9b8282a8a39a474c9b9319f247e2d.png";